var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _c(
      "div",
      {
        directives: [
          {
            name: "observe-out-of-view",
            rawName: "v-observe-out-of-view",
            value: _vm.handleScroll,
            expression: "handleScroll"
          },
          {
            name: "observe-in-of-view",
            rawName: "v-observe-in-of-view",
            value: _vm.hideStickyFooter,
            expression: "hideStickyFooter"
          }
        ],
        attrs: { id: "tiered-plans" }
      },
      [
        _c("h2", { staticClass: "tiered-plans-heading-text" }, [
          _vm._v(
            "\n      Choose a plan for after your " +
              _vm._s(_vm.user.trial_length) +
              "-day free trial\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "tiered-plans-subheading-text" }, [
          _vm._v(
            "\n      Pay $0.00 today. Cancel anytime in the next " +
              _vm._s(_vm.user.trial_length) +
              " days and you won’t be\n      charged.\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "plans" },
          [
            _vm.mathFoundationsPlanAvailable
              ? _c(
                  "PlanCard",
                  {
                    staticClass: "math-plan",
                    attrs: {
                      "plan-title": "Math Foundations",
                      price:
                        _vm.paywallPlans.annualMathFoundationsPlan
                          .display_price,
                      "strikethrough-price": _vm.strikeThroughPrice(
                        _vm.planType(_vm.paywallPlans.annualMathFoundationsPlan)
                      ),
                      checkoutUrl:
                        _vm.paywallPlans.annualMathFoundationsPlan.checkout_url,
                      "plan-type": _vm.planType(
                        _vm.paywallPlans.annualMathFoundationsPlan
                      ),
                      "is-popular": false,
                      "should-show-discount": _vm.shouldShowDiscount
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "plan-billing-blurb",
                        attrs: { slot: "plan-billing-blurb" },
                        slot: "plan-billing-blurb"
                      },
                      [_vm._v("per month, billed annually")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "plan-access-blurb",
                        attrs: { slot: "plan-access-blurb" },
                        slot: "plan-access-blurb"
                      },
                      [
                        _vm._v(
                          "\n          Access to 20+ math courses, covering:\n        "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "PlanCard",
              {
                staticClass: "all-courses-plan",
                attrs: {
                  "plan-title": "All Courses",
                  price: _vm.paywallPlans.annualPlanTrial.display_price,
                  "strikethrough-price": _vm.strikeThroughPrice(
                    _vm.planType(_vm.paywallPlans.annualPlanTrial)
                  ),
                  checkoutUrl: _vm.paywallPlans.annualPlanTrial.checkout_url,
                  "plan-type": _vm.planType(_vm.paywallPlans.annualPlanTrial),
                  "is-popular": true,
                  "should-show-discount": _vm.shouldShowDiscount
                }
              },
              [
                _c(
                  "p",
                  {
                    staticClass: "plan-billing-blurb",
                    attrs: { slot: "plan-billing-blurb" },
                    slot: "plan-billing-blurb"
                  },
                  [_vm._v("per month, billed annually")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "plan-access-blurb",
                    attrs: { slot: "plan-access-blurb" },
                    slot: "plan-access-blurb"
                  },
                  [
                    _vm._v(
                      "\n          Unlimited access to 70+ courses, covering:\n        "
                    )
                  ]
                )
              ]
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "is-fixed", attrs: { id: "sticky-cta" } }, [
      _vm.shouldShowDiscount
        ? _c(
            "p",
            { class: { discount: true, "green-text": true } },
            [
              _c("LightningSvg", { staticClass: "discount-icon" }),
              _vm._v(" "),
              _c("span", { domProps: { innerHTML: _vm._s(_vm.discountHtml) } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "mobile-checkout-btn btn btn-green",
          on: { click: _vm.scrollToTop }
        },
        [
          _vm._v(
            "\n      Start my free " +
              _vm._s(_vm.user.trial_length) +
              " days\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }